export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Operation confirmation"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter confirmation code"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
}